import React, {FC} from 'react';
import {ReactComponent as ExportXlsSvg} from 'resources/icons/export_xls.svg';

export const ExportXlsIcon: FC = () => {
  return <ExportXlsSvg />;
};
